import { useDialogContext } from '../../../../contexts/DialogContext';
import queryClient from '../../../../ReactQuery/client';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { remove } from '../../../../redux/api';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

import { getGitHubAppInstallationQueryKey } from './useGitHubAppInstallation';

const uninstallGitHubApp = (app: VcsApp) => {
  return remove<never, void>(`/api/vcs/github-apps/${app}/installation`);
};

/**
 * Asks the user to confirm, then removes the org's vcs-app connection from vcs-service.
 */
export function useUninstallGitHubApp() {
  const { onConfirm } = useDialogContext();

  const mutation = useToastedMutation({
    mutationFn: (app: VcsApp) => uninstallGitHubApp(app),
    onSuccess: (_data, app) => {
      queryClient.invalidateQueries({ queryKey: getGitHubAppInstallationQueryKey(app) });
    },
    successToastMessage: 'GitHub App disconnected successfully',
    errorToastMessage: 'Failed to disconnect GitHub App',
  });

  const onUninstall = (app: VcsApp) => {
    onConfirm({
      title: 'Disconnect GitHub App',
      body: 'Are you sure you want to disconnect this GitHub App?',
      onConfirm: () => {
        mutation.mutate(app);
      },
    });
  };

  return {
    onUninstall,
    isUninstalling: mutation.isPending,
  };
}
